import { render, staticRenderFns } from "./PopsFolderClinic.vue?vue&type=template&id=16f739b7&scoped=true"
import script from "./PopsFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsFolderClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsFolderClinic.vue?vue&type=style&index=0&id=16f739b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f739b7",
  null
  
)

export default component.exports